import { utils as XLSXUtils, writeFile as writeXlsxFile } from 'xlsx'
import JsPDF from 'jspdf'
import 'jspdf-autotable'

const normalizeValue = value => {
  if (value === null || value === undefined) return ''
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

export const filterRowsBySearch = (rows, searchTerm) => {
  const normalizedSearch = searchTerm.trim().toLocaleLowerCase()
  if (!normalizedSearch) return rows

  return rows.filter(row => Object.values(row).some(value =>
    normalizeValue(value).toLocaleLowerCase().includes(normalizedSearch)
  ))
}

const toExportRows = (rows, columns) => rows.map(row => Object.fromEntries(
  columns.map(column => [column.label, normalizeValue(row[column.key])])
))

export const exportDataEditExcel = ({ rows, columns, fileName, sheetName }) => {
  const worksheet = XLSXUtils.json_to_sheet(toExportRows(rows, columns))
  const workbook = XLSXUtils.book_new()
  XLSXUtils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31))
  writeXlsxFile(workbook, `${fileName}.xlsx`)
}

export const exportDataEditPdf = ({ rows, columns, fileName, title }) => {
  const document = new JsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' })
  document.text(title, 14, 14)
  document.autoTable({
    startY: 20,
    head: [columns.map(column => column.label)],
    body: rows.map(row => columns.map(column => normalizeValue(row[column.key]))),
    styles: { fontSize: 7, overflow: 'linebreak' },
    headStyles: { fillColor: [22, 101, 52] }
  })
  document.save(`${fileName}.pdf`)
}
